import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { SharingSchedulesSettings } from "../../sharing.types";
import { requestUpdateSharingSchedulesSettings } from "./updateSharingSchedulesSettings.request";

const useUpdateSharingSchedulesSettings = (
  options?: MutationOptions<
    void,
    ApiServiceError<ApiError>,
    SharingSchedulesSettings
  >
) => {
  const refetchSharingSchedulesSettings = useRefetchQuery([
    "sharing-schedules-settings"
  ]);

  return useMutation({
    mutationFn: requestUpdateSharingSchedulesSettings,
    ...options,
    onSuccess: (...args) => {
      refetchSharingSchedulesSettings();
      options?.onSuccess?.(...args);
    }
  });
};

export default useUpdateSharingSchedulesSettings;
